module.exports = require('./SalesFinanceApplicationView');
